module.exports = require('./SalesFinanceApplicationView');
